import { motion } from 'framer-motion';
import { Instagram, Facebook, Star, MapPin } from 'lucide-react';

const SOCIAL_LINKS = {
  instagram: 'https://www.instagram.com/abbamassage',
  facebook: 'https://www.facebook.com/abbamassage',
  tripadvisor: 'https://www.tripadvisor.com.mx/Attraction_Review-g150807-d34151326-Reviews-Abba_Massage_Studio_and_Wellness_Center-Cancun_Yucatan_Peninsula.html',
  google: 'https://maps.app.goo.gl/G2JL5nKRZdTESBVXA',
};

export const SocialSidebar = () => {
  return (
    <motion.div
      initial={{ x: -100, opacity: 0 }}
      animate={{ x: 0, opacity: 1 }}
      transition={{ delay: 1.5, type: 'spring', stiffness: 100 }}
      className="fixed left-0 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-0"
      data-testid="social-sidebar"
    >
      <a
        href={SOCIAL_LINKS.instagram}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center w-12 h-12 bg-[#A91B60] hover:bg-[#8A1650] text-white transition-all hover:w-36 overflow-hidden"
        data-testid="social-instagram"
      >
        <Instagram className="w-5 h-5 flex-shrink-0" />
        <span className="ml-2 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Instagram
        </span>
      </a>
      
      <a
        href={SOCIAL_LINKS.facebook}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center w-12 h-12 bg-[#1877F2] hover:bg-[#1565D8] text-white transition-all hover:w-36 overflow-hidden"
        data-testid="social-facebook"
      >
        <Facebook className="w-5 h-5 flex-shrink-0" />
        <span className="ml-2 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Facebook
        </span>
      </a>
      
      <a
        href={SOCIAL_LINKS.tripadvisor}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center w-12 h-12 bg-[#00AF87] hover:bg-[#009977] text-white transition-all hover:w-36 overflow-hidden"
        data-testid="social-tripadvisor"
      >
        <MapPin className="w-5 h-5 flex-shrink-0" />
        <span className="ml-2 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          TripAdvisor
        </span>
      </a>
      
      <a
        href={SOCIAL_LINKS.google}
        target="_blank"
        rel="noopener noreferrer"
        className="group flex items-center justify-center w-12 h-12 bg-[#4285F4] hover:bg-[#3367D6] text-white transition-all hover:w-36 overflow-hidden"
        data-testid="social-google"
      >
        <Star className="w-5 h-5 flex-shrink-0" />
        <span className="ml-2 text-xs font-medium opacity-0 group-hover:opacity-100 transition-opacity whitespace-nowrap">
          Google Reviews
        </span>
      </a>
    </motion.div>
  );
};

export default SocialSidebar;
